
<div class="modal-content schema-settings-modal-content">
    <div class="p-3 schema-settings-modal-header d-flex justify-content-between align-items-end">
        <h5 class="schema-settings-modal-title">
            <i class="bi bi-wrench-adjustable-circle me-2"></i>
            Schema Settings
        </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="schema-settings-modal-body p-3">
        <div class="d-flex align-items-center justify-content-between py-2">
            <span class="checkbox-label">Require Provenance</span>
            <label class="switch">
                <input type="checkbox" name="requireProvenance" [(ngModel)]="formValues.requireProvenance" />
                <span class="slider round"></span>
            </label>
        </div>
        <div class="d-flex align-items-center justify-content-between py-2">
            <span class="checkbox-label">Fast Conversion</span>
            <label class="switch">
                <input type="checkbox" name="fastConversion" [(ngModel)]="formValues.fastConversion" />
                <span class="slider round"></span>
            </label>
        </div>
        <div class="d-flex align-items-center justify-content-between py-2">
            <span class="checkbox-label">Allow multiple rows</span>
            <label class="switch">
                <input type="checkbox" name="multiple_rows" [(ngModel)]="formValues.multiple_rows" />
                <span class="slider round"></span>
            </label>
        </div>
        <div class="d-flex align-items-end justify-content-between py-2">
            <span class="input-label me-3">Schema Splitting Threshold</span>
            <input type="number" align="right" name="schemaSplittingThreshold" [(ngModel)]="formValues.schemaSplittingThreshold" class="form-control threshold-input" />
        </div>
        <div class="d-flex align-items-end justify-content-between py-2">
            <span class="input-label me-3">N-Shot Validation</span>
            <input type="number" align="right" name="n_shot" [(ngModel)]="formValues.n_shot" class="form-control threshold-input" />
        </div>
    </div>
    <div class="d-flex gap-3 justify-content-end p-3" >
        <button type="button" class="simple-button btn-md" (click)="onCancel()">Cancel</button>
        <button type="button" class="purple-button btn-md" (click)="onSave()">Save Settings</button>
    </div>
</div>
